import styled from "styled-components";
import { media } from "../../../../utils";

export const SimulacaoButton = styled.button`
  width: 100%;
  ${media.md()} {
    max-width: 296px;
  }
`;

export const Important = styled.span(({ theme }) => ({
  color: theme.color.neutral["03"],
  paddingTop: "16px",
}));

export const LogoMobile = styled.svg`
  ${media.md()} {
    display: none;
  }
`;

export const ImageMobileContent = styled.div`
  text-align: center;
`;
